@let tasks = tasks$ | async;
@let summary = summary$ | async;

<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Solicitações'"
    [titleIcon]="'pi pi-list-check'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      { label: 'Solicitações', icon: 'pi pi-list-check' },
    ]"></app-page-header>

  <div class="container-fluid solicitations">
    <!-- Summary Cards -->
    <section class="solicitations__summary-cards">
      @if (summary) {
        <app-status-summary-card
          label="APROVADAS"
          colorVariant="approved"
          [count]="summary.approved"
          [active]="activeStatusFilter === taskStatusEnum.APPROVED"
          (cardClick)="handleStatusFilter(taskStatusEnum.APPROVED)" />
        <app-status-summary-card
          label="PENDENTES"
          colorVariant="pending"
          [count]="summary.pending"
          [active]="activeStatusFilter === taskStatusEnum.PENDING"
          (cardClick)="handleStatusFilter(taskStatusEnum.PENDING)" />
        <app-status-summary-card
          label="REJEITADAS"
          colorVariant="rejected"
          [count]="summary.rejected"
          [active]="activeStatusFilter === taskStatusEnum.REJECTED"
          (cardClick)="handleStatusFilter(taskStatusEnum.REJECTED)" />
      } @else {
        <p-skeleton height="90px" />
        <p-skeleton height="90px" />
        <p-skeleton height="90px" />
      }
    </section>

    <!-- Search + Results Count -->
    <section class="solicitations__search-section">
      <div class="solicitations__search">
        <p class="solicitations__search-label">BUSCAR TASK</p>
        <p-iconField iconPosition="left">
          <p-inputIcon>
            <i class="pi pi-search"></i>
          </p-inputIcon>
          <input pInputText [formControl]="tableFilter" placeholder="Buscar" />
        </p-iconField>
      </div>
      <div class="solicitations__search-actions">
        @if (tasks) {
          <app-paginator-report
            [meta]="tasks.meta"
            [template]="'Exibindo {first}–{last} de {totalRecords} resultados'" />
        }
        <app-button styleType="outlined" [disabled]="!hasActiveFilters" (btnClick)="clearFilters()">
          Limpar filtros
        </app-button>
      </div>
    </section>

    <!-- Table -->
    <section class="solicitations__table-section">
      <app-solicitations-table
        [data]="tasks!"
        (pageChange)="handlePageChange($event)"
        (viewDetailsClick)="handleViewDetails($event)" />
    </section>
  </div>
</app-layout>
